import { forwardRef } from 'react';
import { Flex, Switch, type SwitchProps } from '@chakra-ui/react';
import { Text } from '../../typography';

interface ToggleProps extends Omit<SwitchProps, 'size'> {
    checked?: boolean;
    onCheckedChange?: (checked: boolean) => void;
    id?: string;
    label?: string;
    description?: string;
    variant?: 'slt' | 'new-toggle';
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
    ({ id, label, description, ...props }, ref) => (
        <Flex direction="column" gap={1}>
            <Flex gap={2} alignItems="center">
                <Switch ref={ref} data-testid={id} id={id} {...props} />
                {label && <Text style="bold">{label}</Text>}
            </Flex>
            {description && <Text id="toggle-description">{description}</Text>}
        </Flex>
    ),
);

Toggle.displayName = 'Toggle';
